import TextField from '@material-ui/core/TextField';
import React from 'react';
import QRCode from 'qrcode.react';

import { isMfaLoginActionDisabled } from './mfaLoginState';
import { MFA_SETUP_INSTRUCTIONS } from './mfaSetupInstructions';
import MFA_TEXTS from './mfaTexts';

function MfaLoginChallenge({ mfa, code, loading, appDetails, onCodeChange, onVerify, onBack }) {
    const isSetupRequired = Boolean(mfa.setupRequired);
    const primaryButtonColor =
        appDetails?.loginPageCustomization?.primaryButtonColor ||
        appDetails?.primaryColor;
    const primaryButtonTextColor =
        appDetails?.loginPageCustomization?.primaryButtonTextColor ||
        appDetails?.secondaryColor;

    return (
        <>
            <div className="mfa-login-header">
                <h4>{MFA_TEXTS.login.title}</h4>
                <span>{isSetupRequired ? MFA_TEXTS.login.setupIntro : MFA_TEXTS.login.recurringIntro}</span>
            </div>

            {isSetupRequired && (
                <div className="mfa-login-enrollment">
                    <ol className="mfa-login-instructions">
                        {MFA_SETUP_INSTRUCTIONS.map((instruction) => (
                            <li key={instruction}>{instruction}</li>
                        ))}
                    </ol>
                    {mfa.otpauthUrl && (
                        <div className="mfa-login-qrcode">
                            <QRCode value={mfa.otpauthUrl} size={168} />
                        </div>
                    )}
                    {mfa.secret && (
                        <div className="mfa-login-secret">
                            <span>{MFA_TEXTS.login.manualKeyLabel}</span>
                            <strong>{mfa.secret}</strong>
                        </div>
                    )}
                </div>
            )}

            <TextField
                id="standard-basic-mfa"
                type="text"
                style={{ width: '100%', marginTop: 10 }}
                label={MFA_TEXTS.login.verificationCodeLabel}
                placeholder={MFA_TEXTS.login.verificationCodePlaceholder}
                value={code}
                disabled={loading}
                onChange={(event) => onCodeChange(event.target.value)}
                onKeyDown={(event) => event.key === 'Enter' && onVerify()}
                inputProps={{
                    inputMode: 'numeric',
                    maxLength: 6,
                    pattern: '[0-9]*',
                    autoComplete: 'one-time-code',
                    'aria-required': true,
                }}
            />

            <div className="mfa-login-actions">
                <button
                    className="btn botao-login"
                    type="button"
                    disabled={isMfaLoginActionDisabled({ loading, code })}
                    style={{
                        backgroundColor: primaryButtonColor,
                        borderColor: 'transparent',
                        color: primaryButtonTextColor,
                    }}
                    onClick={onVerify}
                >
                    <>
                        {loading
                            ? MFA_TEXTS.login.validatingAction
                            : isSetupRequired
                                ? MFA_TEXTS.login.setupAction
                                : MFA_TEXTS.login.validateAction}
                    </>
                    {loading && (
                        <div style={{ marginLeft: 10 }}>
                            <div className="loader" style={{ position: 'relative', right: 0 }} />
                        </div>
                    )}
                </button>
                <button className="mfa-login-back" type="button" onClick={onBack}>
                    {MFA_TEXTS.login.backAction}
                </button>
            </div>
        </>
    );
}

export default MfaLoginChallenge;
